import React from "react";
import BuyBidding from "../../images/buy-bidding.png";
import CarsBidding from "../../images/cars-live-bidding.webp";
import FwInspection from "../../images/services-icon/famewheels-inspection.png";
import SellFamewheels from "../../images/sell-famewheels.png";
import InsuranceIcon from "../../images/car-insurance-icon.png";
import FinanceIcon from "../../images/car-finance-icon.png";
import { Link } from "react-router-dom";

const PriceCallService = () => {
  const services = [
    { img: SellFamewheels, title: "Sell Your Car", link: "/ad-category" },
    { img: InsuranceIcon, title: "Car Insurance", link: "/car-insurance" },
    { img: FwInspection, title: "Car Inspection", link: "/car-inspection" },
    {
      img: BuyBidding,
      title: "Sell Through Live Bidding",
      link: "/sell-through-live-bidding",
    },
    {
      img: SellFamewheels,
      title: "Sell Through Famewheels",
      link: "/ad-category",
    },
    { img: FinanceIcon, title: "Car Finance", link: "/car-finance" },
  ];
  return (
    <>
      <div className="container width-class   mx-auto  mt-3 mb-5 pt-md-5 mt-md-5">
        <div className="row justify-content-center align-items-stretch g-md-2">
          {services.map((service, index) => (
            <div key={index} className="col-6 col-md-5 col-lg-4 d-flex">
              <div className="card cardClass shadow-sm h-md-100   w-100 d-flex flex-column flex-md-row align-items-center">
                <img
                  src={service.img}
                  alt={service.title}
                  className="img-fluid imgClass mt-3 mt-md-0"
                  style={{ maxWidth: "100px", height: "auto" }}
                />
                <div className="card-body w-md-75 flex-grow-1">
                  <h5 className="card-title text-black">{service.title}</h5>
                  <Link
                    className="btn btn-sm fw-bold btnClass text-danger"
                    to={service.link}
                  >
                    Explore More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PriceCallService;
